import { DepartmentList } from './department-list';
import DepartmentDetail from './department-detail';

export { DepartmentList, DepartmentDetail };
